import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface OpenIntegrationsRequest {
  /** The section to open on: a project's integrations unless told otherwise. */
  section?: 'projects-general' | 'workspace-general';
  projectId?: string;
  /**
   * The integration the user is coming back from, when the request is an OAuth return.
   * It also decides which settings section the modal opens on.
   */
  integration?: 'slack' | 'webflow-mcp' | 'hubspot';
  /** The Slack workspace link the round trip just installed, so the dialog can open on it. */
  workspaceLinkId?: string;
  /** The slug the provider sent back when the round trip failed, and nothing when it worked. */
  error?: string;
}

/**
 * BehaviorSubject (not a plain Subject): the settings modal lives on the dashboard
 * shell, which may not be instantiated yet when a route guard fires this request
 * (guards for the whole route tree resolve before parent components mount), so the
 * last value must replay to a late subscriber.
 */
@Injectable({ providedIn: 'root' })
export class SettingsModalTriggerService {
  private readonly request$ = new BehaviorSubject<OpenIntegrationsRequest | null>(null);
  readonly openIntegrationsRequest$ = this.request$.asObservable();

  requestOpenIntegrations(request: OpenIntegrationsRequest = {}): void {
    this.request$.next(request);
  }

  /** Opens the settings on the workspace's own section, where AI execution is set up. */
  requestOpenWorkspaceSettings(): void {
    this.request$.next({ section: 'workspace-general' });
  }

  clearRequest(): void {
    this.request$.next(null);
  }
}
